import React from "react";
import "./Banner.scss";

import { getFlagUrl } from "../../utils/getFlagUrl";
import usFlag from "../../assets/flags/USD.svg";
import emami from "../../assets/coins/emami.png";
import down from "../../assets/icons/down.svg";
import up from "../../assets/icons/up.svg";
import check from "../../assets/icons/check.svg";
import MiniChart from "../Charts/MiniChart";

const Banner = ({ currencies, coins, viewsData }) => {
  const calculatePercentageChange = (price, previousPrice) => {
    if (previousPrice === 0) {
      return "N/A"; // Avoid division by zero
    }

    const change = ((price - previousPrice) / previousPrice) * 100;
    const sign = change > 0 ? "+" : ""; // Add "+" sign for positive change
    return `${sign}${change.toFixed(2)}%`; // Return as string with 2 decimal places
  };

  const scrollToPrices = () => {
    const pricesElement = document.getElementById("prices");
    if (pricesElement) {
      pricesElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  const scrollToCharts = () => {
    const pricesElement = document.getElementById("charts");
    if (pricesElement) {
      pricesElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="banner-container wide-page-margin">
      <div className="right-banner">
        <div className="gradient-btn-2 w-fit">شماره ثبت :۵۱۰۲۸۳</div>
        <div>
          <div className="title-1">صـــرافــی آی اکـــس</div>
          <div className="title-2">شرکت تضامنی محبوبه اشراقی و شرکا</div>
        </div>
        <div>
          <div className="desc-1">
            با نام تجاری صرافی آی اکس در تاریخ 1396/3/13 در اداره کل ثبت شرکت ها
            به ثبت رسیده و موفق به دریافت مجوز رسمی از بانک مرکزی جمهوری اسلامی
            ایران گردیده است.
          </div>
          <div className="banner-btns">
            <button onClick={scrollToPrices} className="gradient-btn-1 w-fit">
              مشاهده نرخ ارز و سکه
            </button>
            <button className="gradient-btn-3 w-fit">
              <a href="/prices">مشاهده نرخ های جهانی</a>
            </button>
          </div>
          <div className="views">
            <div className="color-text-1">
              <img src={check} alt="view" />
              {`
              بازدید امروز : ${viewsData.today} نفر
              `}
            </div>
            <div className="color-text-1">
              <img src={check} alt="view" />
              {`
              بازدید دیروز : ${viewsData.yesterday} نفر
              `}
            </div>
            <div className="color-text-1">
              <img src={check} alt="view" />
              {`بازدید کل : ${viewsData.all} نفر`}
            </div>
          </div>
        </div>
      </div>
      <div className="left-banner">
        <div className="card-1">
          <div className="">
            <div className="flex items-center gap-[0.94rem]">
              <div>
                <img src={usFlag} alt="flag" />
              </div>
              <div className="flex flex-col">
                <span className="name">نرخ {currencies[0]?.currency.name}</span>
                <span className="symbol">{currencies[0]?.currency.symbol}</span>
              </div>
            </div>
            <div>
              <div className="price">
                {currencies[0]?.sellPrice.toLocaleString()} تومان
              </div>
              <div className="flex gap-[0.25rem]">
                <span
                  className={
                    currencies[0]?.sellPrice > currencies[0]?.pSellPrice
                      ? "btn-3"
                      : "btn-2"
                  }
                >
                  {currencies[0] &&
                    calculatePercentageChange(
                      currencies[0].sellPrice,
                      currencies[0].pSellPrice
                    )}
                  <img
                    src={
                      currencies[0]?.sellPrice > currencies[0]?.pSellPrice
                        ? up
                        : down
                    }
                    alt=""
                  />
                </span>
                <button onClick={scrollToPrices} className="btn-1">
                  کلیک کنید
                </button>
              </div>
            </div>
          </div>
          {currencies[0] && (
            <MiniChart data={currencies[0]} type={"currency"} />
          )}
        </div>
        <div className="flex justify-center items-start gap-[1.94rem] max-[540px]:gap-[0.5rem]">
          <div className="card-2">
            <div className="head flex gap-[4.37rem] items-start max-[540px]:gap-[0rem]">
              <span className="title">برخی از نرخ فروش ارزها</span>
              <button onClick={scrollToPrices} className="btn-1">
                کلیک کنید
              </button>
            </div>
            <table className="mini-price-table">
              <tbody>
                {currencies?.slice(1, 5).map((currency, index) => (
                  <tr key={index}>
                    <td className="">
                      <span className="currency-flag">
                        <img
                          src={getFlagUrl(currency.currency.symbol)}
                          alt={currency.currency.name}
                          className=""
                        />
                      </span>
                      <span className="currency-name">
                        <div className="flex flex-col">
                          <span>{currency.currency.name} </span>
                          <span className="symbol">
                            {currency.currency.symbol}
                          </span>
                        </div>
                      </span>
                    </td>
                    <td>
                      <div className="price-value">
                        <span className={`price-icon`}>
                          <span
                            className={`change ${
                              currency?.sellPrice > currency?.pSellPrice
                                ? "green"
                                : "red"
                            }`}
                          >
                            {calculatePercentageChange(
                              currency.sellPrice,
                              currency.pSellPrice
                            )}
                          </span>
                          <img
                            src={
                              currency?.sellPrice > currency?.pSellPrice
                                ? up
                                : down
                            }
                            alt=""
                          />
                        </span>
                        {currency.sellPrice.toLocaleString()}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="card-2 gap-[1rem]">
            <div className="head flex justify-between items-start gap-[4.42rem]">
              <div className="flex ">
                <img src={emami} alt="" />
                <div className="coin-text">
                  <div className="title">نرخ {coins[0]?.coin.name}</div>
                  <div className="mini-title">سکه امامی</div>
                </div>
              </div>
              <button onClick={scrollToPrices} className="btn-1">
                کلیک کنید
              </button>
            </div>
            <div>
              <div className="coin-price">
                {coins[0]?.sellPrice.toLocaleString()} تومان
              </div>
              <span
                className={
                  coins[0]?.sellPrice > coins[0]?.pSellPrice ? "btn-3" : "btn-2"
                }
              >
                <img
                  src={coins[0]?.sellPrice > coins[0]?.pSellPrice ? up : down}
                  alt=""
                />
                {coins[0] &&
                  calculatePercentageChange(
                    coins[0].sellPrice,
                    coins[0].pSellPrice
                  )}
              </span>
            </div>
            {coins[0] && <MiniChart data={coins[0]} type={"coin"} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
